import { UnfoldLess, UnfoldMore } from '@mui/icons-material';
import SecondLevelTable from './SecondLevelTable';
import { ILawFirstLevelTableData } from '../types/lawColumn.types';

const secondLevelTableWrapper = (
  current: boolean,
  activeFund: { fundId: string; fundName: string },
  version?: number,
) => [
  (rowData: ILawFirstLevelTableData) => {
    const icon = () => (rowData.assets.length ? <UnfoldMore /> : <></>);
    const render = () => (
      <SecondLevelTable
        data={rowData}
        fundDetails={activeFund}
        ruleNumber={rowData.rule_number}
        positionDate={rowData.positionDate}
        version={version}
      />
    );
    return {
      disabled: !rowData.assets.length || !current,
      icon,
      openIcon: UnfoldLess,
      render,
    };
  },
];

export default secondLevelTableWrapper;
